module.exports = __webpack_public_path__ + "static/media/coke.e82f8c41.usdz";